module.exports = __webpack_public_path__ + "img/compatability.1647b3ff.png";